import type { AssessmentScope } from "@peer-start/platform-contracts";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "../../../app/use-app-context.js";
import {
  fetchAssessment,
  fetchAssessments,
  fetchLatestAssessment,
  fetchAssessmentOverview,
} from "./client.js";

export function useAssessments() {
  const { persona } = useAppContext();
  return useQuery({
    queryKey: ["assessments", persona.id],
    queryFn: fetchAssessments,
    enabled: persona.kind === "employee",
  });
}
export function useAssessment(id: string) {
  const { persona } = useAppContext();
  return useQuery({
    queryKey: ["assessment", persona.id, id],
    queryFn: () => fetchAssessment(id),
    enabled: !!id,
  });
}
export function useLatestAssessment(id: string, scope?: AssessmentScope) {
  const { persona } = useAppContext();
  return useQuery({
    queryKey: ["assessment-latest", persona.id, id, scope],
    queryFn: () => fetchLatestAssessment(id, scope),
    enabled: !!id,
  });
}

export function useAssessmentOverview() {
  const { persona } = useAppContext();
  return useQuery({
    queryKey: ["assessment-overview", persona.id],
    queryFn: fetchAssessmentOverview,
    enabled: persona.kind === "employee",
  });
}
